module.exports = __webpack_public_path__ + "img/guide_pic_whiteB.370eaa3b.png";